import React from "react"
import Link from "components/Link"
import MarkdownContent from "components/MarkdownContent"
import {
  useFooterContent,
  useFooterPrimaryMenu,
  useFooterSecondaryMenu,
} from "effects/useSiteContent"
import presetBackground from "./background.svg"
import facebookIcon from "./facebook.svg"
import linkedinIcon from "./linkedin.svg"
import logoIcon from "./logo.svg"
import twitterIcon from "./twitter.svg"
import instagramIcon from "./instagram.svg"
import youtubeIcon from "./youtube.svg"

function Footer() {
  /** Footer content from local YAML */
  const { social, companyAddress, footerText } = useFooterContent()

  /** Navigation menus from local YAML (migrated from Contentful) */
  const footerPrimaryMenu = useFooterPrimaryMenu()
  const footerSecondaryMenu = useFooterSecondaryMenu()

  return (
    <footer className="relative mt-16">
      <div className="px-5 lg:container">
        <img
          className="absolute left-0 top-0"
          src={presetBackground}
          alt="Preset"
        />
        <div className="relative z-10 py-10">
          <div className="grid grid-cols-2 gap-x-10 gap-y-12 md:grid-cols-3 md:gap-x-5 lg:grid-cols-6 lg:gap-x-10 lg:gap-y-10">
            <div className="col-span-2 md:col-span-3 lg:col-span-1">
              <Link href="/" title="Home">
                <img src={logoIcon} alt="Logo" width={40} />
              </Link>
              <div className="mt-7 text-sm">
                {companyAddress?.line1}
                <br />
                {companyAddress?.line2}
              </div>
              {social && (
                <ul className="mt-7 flex items-center gap-x-4">
                  <li>
                    <Link href={social.twitter?.url} openNewTab>
                      <img src={twitterIcon} alt="X" className="h-6 w-6" />
                    </Link>
                  </li>
                  <li>
                    <Link href={social.linkedin?.url} openNewTab>
                      <img
                        src={linkedinIcon}
                        alt="LinkedIn"
                        className="h-6 w-6"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link href={social.youtube?.url} openNewTab>
                      <img
                        src={youtubeIcon}
                        alt="YouTube"
                        className="h-6 w-6"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link href={social.instagram?.url} openNewTab>
                      <img
                        src={instagramIcon}
                        alt="Instagram"
                        className="h-6 w-6"
                      />
                    </Link>
                  </li>
                  {social.facebook?.url && (
                    <li>
                      <Link href={social.facebook?.url} openNewTab>
                        <img
                          src={facebookIcon}
                          alt="Facebook"
                          className="h-6 w-6"
                        />
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </div>
            {footerPrimaryMenu?.map((menuItem) => (
              <div key={menuItem.label}>
                <h4 className="text-xl font-bold">
                  {menuItem.path ? (
                    <Link href={menuItem.path}>{menuItem.label}</Link>
                  ) : (
                    menuItem.label
                  )}
                </h4>
                {menuItem.items?.length > 0 && (
                  <ul className="mt-4 space-y-2 text-sm">
                    {menuItem.items.map((item) => (
                      <li key={item.label}>
                        <Link href={item.path}>{item.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
          <div className="mt-20 md:text-center">
            <ul className="divide-x text-xs text-neutral-500">
              {footerSecondaryMenu?.map((menuItem) => (
                <Link
                  className="px-2 first:pl-0 last:pr-0"
                  href={menuItem.path}
                  key={menuItem.label}
                >
                  {menuItem.label}
                </Link>
              ))}
            </ul>
            <MarkdownContent
              className="mt-2 max-w-[300px] text-xs text-neutral-500 md:mx-auto"
              rawMarkdownBody={footerText?.replace(
                "{year}",
                new Date().getFullYear()
              )}
            />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
